import { oc } from '@orpc/contract';
import { stageSheetsInputSchema, stageSheetsOutputSchema } from '../schemas/board.schemas.js';
/** A read, sent as POST because its input carries the nested `period` union (like `reports.steering`). */
export const getStageSheetsContract = oc
    .route({
    method: 'POST',
    path: '/board/stage-sheets',
    tags: ['Board'],
    summary: 'The print-ready report sheets of one journey stage over a period, every value from its bound KPI (every role)',
})
    .input(stageSheetsInputSchema)
    .output(stageSheetsOutputSchema);
//# sourceMappingURL=get-stage-sheets.contract.js.map